import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePermisos } from './usePermisos';

export const usePermisosGuard = (modulo, permiso = 'ver') => {
  const { can } = usePermisos();
  const navigate = useNavigate();
  const { codigo } = useParams();

  useEffect(() => {
    if (!can(modulo, permiso)) {
      const tenantCodigo = codigo || localStorage.getItem('tenant_codigo');
      const destino = tenantCodigo ? `/${tenantCodigo}/dashboard` : '/dashboard';
      navigate(destino, { replace: true });
    }
  }, [can, modulo, permiso, navigate, codigo]);
};


